import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';
import { Subject, Observable } from 'rxjs';
import { BeneficiaryEmploymentDto } from '../../beneficiaries/beneficiary-details/employment/dto/beneficiary-employment.dto';

@Injectable({
  providedIn: 'root',
})
export class BeneficiaryEmploymentService {
  public employmentUpdate: Subject<BeneficiaryEmploymentDto> = new Subject<BeneficiaryEmploymentDto>();
  public employmentUpdated$: Observable<BeneficiaryEmploymentDto> = this.employmentUpdate.asObservable();

  constructor(private readonly api: ApiService) {}

  public async findById(idEmployment: number): Promise<BeneficiaryEmploymentDto> {
    const uri: string = environment.api.employments + '/' + idEmployment + '/details';
    const result: BeneficiaryEmploymentDto = await this.api.get<BeneficiaryEmploymentDto>(uri);

    return BeneficiaryEmploymentDto.fromJson(result);
  }

  public async updateEmploymentBeneficiary(
    idBeneficiary: number,
    beneficiaryEmployment: BeneficiaryEmploymentDto,
  ): Promise<BeneficiaryEmploymentDto> {
    const uri: string = environment.api.employments + '/' + idBeneficiary;
    const result: BeneficiaryEmploymentDto = await this.api.put(uri, beneficiaryEmployment);
    this.employmentUpdate.next(result);
    return result;
  }
}
